import gql from 'graphql-tag';

const GET_ALL = gql `
    query all($perPage: Int!, $page: Int, $where: HakAksesPenggunaWhereWhereConditions){
        hakAksesPengguna(first: $perPage, page: $page, where: $where){
            data{
              id
              pengguna_id
              hak_akses_id
              pengguna{
                id 
                uuid
                nama
                jabatan{
                  id
                  nama
                }
              }
            }
            paginatorInfo {
              count
              total
              hasMorePages
              currentPage
              lastPage
              perPage
            }
        }
    }
`;

const CREATE = gql `
  mutation($input:HakAksesPenggunaCreateInput!){
    HakAksesPenggunaCreate(input:$input){
      id
      pengguna_id
      hak_akses_id
    }
  }
`
const DELETE = gql `
  mutation HakAksesPenggunaDelete($id: ID!){
    HakAksesPenggunaDelete(id: $id){
      id
      pengguna_id
      hak_akses_id
    }
  }
`

export {
  GET_ALL,
  CREATE,
  DELETE
}
